import { useMemo } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";



const Projects = () => {

    const projectsData = useMemo(() => [
        {
            title: 'EDGES',
            description: 'Efficient and scalable direct sampling schema for Gaussian linear random effects models. Uses Gaussian conjugate inference to outperform traditional MCMC and give higher effective sample size. Scalable due to matrix sketching and Nystrom low-rank approximations.',
            tags: 'Python'
        },
        {
            title: 'HeLP Algorithm',
            description: 'Novel algorithm I created for automated rezoning of statistical regions. Leverages graph traversal heuristics, Monte Carlo Tree Search and genetic algorithm look-ahead strategy. Operates in O(n log n) time. Published on Anaconda as a `helprezone` package.',
            tags: 'Python'
        },
        {
            title: 'PLUM Algorithm',
            description: 'Implementation of the Maximum Sum of Evidence algorithm wiht a Pose Look-up Method for accurate pose estimation and object detection in 3D large point cloud data.',
            tags: 'C++ (CUDA)'
        },
        {
            title: 'Services Queensland',
            description: 'A web platform to assess availability of critical services such as hospitals, grocery stores, etc. The app also allows the users to alter their routes with editing tools to emulate floods, other natural disasters or road closures.',
            tags: 'React, Tailwind, Firebase, ArcGIS SDK JS'
        },
        {
            title: 'Pixel Scan',
            description: 'A  platform to detect pixel-wise image differences. Used in operations optimization for surveying and civil engineering.',
            tags: 'React, Tailwind, AWS, Python, Fast API'
        },
        {
            title: 'ADAC Renderer',
            description: 'A web platform for rendering of XML files used in civil engineering (ADAC format).',
            tags: 'React, Tailwind, AWS, ArcGIS SDK JS'
        },
        {
            title: 'Docket App',
            description: 'Web platform for digitalization of corporate operations tickets (cadastral surveygin dockets).',
            tags: 'React, Tailwind, AWS'
        },
        {
            title: 'K-mer Parallel Reader',
            description: 'High-performance parallel file reader and processor of protein k-mer signatures.',
            tags: 'C++ (CUDA)'
        },
        {
            title: 'DART Platform',
            description: 'Driver Augmented Run Training is a desktop application that reviewed and simulated a train driver`s approach to a stop signal based off telemetric data.',
            tags: 'C#, ArcGIS Pro SDK CSharp'
        },
        {
            title: 'Injury Prediction',
            description: 'Prediction of lower limb injuries using generalised linear mixture models, random forests, Kaplan-Meier and the Cox proportional hazards models.',
            tags: 'R'
        },
        {
            title: 'QWildlife Dashboard',
            description: 'ArcGIS Online Dashboard for project management and organizational processs optimization.',
            tags: 'ArcGIS Pro, JS, PostgreSQL, AWS'
        },
        {
            title: 'Coral Modelling',
            description: 'Modelling of the distribution and ratio of coverage of coral in Western Australia with generalised linear mixed models (GLMM).',
            tags: 'R'
        },
        {
            title: 'Stock Prices',
            description: 'Prediction of ASX Bank of Queensland stock price using autoregressive integrated moving average models (ARIMA).',
            tags: 'R'
        },
        {
            title: 'Billboard Manager',
            description: 'A client-server application in Java that manages users and allows them to create and schedule billboards.',
            tags: 'Java'
        },
        {
            title: 'Micro Tom and Jerry',
            description: 'Created a Pacman-style Tom and Jerry game on a microprocessor.',
            tags: 'C++'
        }

    ], []);

    return (
        <div className="flex flex-col min-h-screen w-full items-center">
            <Header />
            <main className="bg-topography flex flex-col items-center justify-start w-full flex-grow py-8">
                {/* Top Spacer */}
                <div className="h-24" />

                {/* Responsive Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 w-full max-w-7xl px-4">
                    {projectsData.map((item, index) => (
                        <div
                            key={index}
                            className="border-accent border-2 rounded-2xl shadow-md hover:shadow-lg transition-shadow p-5 flex flex-col"
                        >
                            <h2 className="text-lg font-bold text-primary mb-2 break-words">
                                {item.title}
                            </h2>
                            <p className="text-text flex-grow break-words">{item.description}</p>
                            <div className="mt-3">
                                <span className="inline-block px-3 py-1 text-sm font-medium text-white bg-accent rounded-full break-words">
                                    {item.tags}
                                </span>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Bottom Spacer */}
                <div className="h-12" />
            </main>
            <Footer />
        </div>
    );

}

export default Projects